// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kjBP","left":"styles_left__SinoS"};